var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepliedinline = function SvgRepliedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#replied_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A9AA1",
    d: "M4.76 12.16c-.448-.64-.672-1.408-.672-2.336 0-1.344.384-2.432 1.184-3.2S7.192 5.472 8.6 5.408v1.504c-.96.032-1.632.288-2.048.8-.448.512-.64 1.12-.64 1.76 0 .192 0 .352.032.416.256-.256.608-.384 1.088-.384.512 0 .896.16 1.216.448.32.32.48.736.48 1.28q0 .816-.576 1.344c-.384.352-.896.512-1.536.512-.768 0-1.408-.288-1.856-.928m5.536 0c-.448-.64-.672-1.408-.672-2.336 0-1.344.384-2.432 1.184-3.2s1.92-1.152 3.328-1.216v1.504c-.96.032-1.632.288-2.048.8-.448.512-.64 1.12-.64 1.76 0 .192 0 .352.032.416.256-.256.608-.384 1.088-.384.512 0 .896.16 1.216.448.32.32.48.736.48 1.28q0 .816-.576 1.344c-.384.352-.896.512-1.536.512-.768 0-1.408-.288-1.856-.928"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "replied_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgRepliedinline;